import { initializeApp } from "firebase/app";

const firebaseApp = initializeApp({
  apiKey: "AIzaSyBCN42iAP4i3_QUcP9HRALRmCuZtA1iLEM",
  authDomain: "sigofood.firebaseapp.com",
  databaseURL: "https://sigofood.firebaseio.com",
  projectId: "sigofood",
  storageBucket: "sigofood.appspot.com",
  messagingSenderId: "582260499402",
  appId: "1:582260499402:web:1248cf433a10147c31e533",
  measurementId: "G-GZ7H66K0CQ"
});
export default firebaseApp